(function(){
  "use strict";

  var STORAGE_KEY = "tf_address";
  var OLD_STORAGE_KEY = "selectedAddress";
  var URL_PARAM = "address";
  var QLD_BOUNDS = { south: -29.18, west: 138, north: -10, east: 154 };

  function getAddress() {
    return localStorage.getItem(STORAGE_KEY) || localStorage.getItem(OLD_STORAGE_KEY) || "";
  }

  function setAddress(addr) {
    if (addr && addr.trim()) {
      localStorage.setItem(STORAGE_KEY, addr.trim());
      localStorage.setItem(OLD_STORAGE_KEY, addr.trim());
    }
  }

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  // Restore address from URL param
  var urlAddr = getUrlParam(URL_PARAM);
  if (urlAddr) setAddress(urlAddr);

  // =========================================================
  // CUSTOM AUTOCOMPLETE (replaces Google's widget entirely)
  // Uses AutocompleteService API + our own dropdown DOM
  // This gives us 100% control over touch events on iOS
  // =========================================================
  window.initTFAddressAutocomplete = function() {
    var input = document.getElementById("address-input");
    if (!input || input.__customAC) return;
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    // Remove any Google autocomplete pac-containers AND prevent new ones
    document.querySelectorAll(".pac-container").forEach(function(el) { el.remove(); });

    // MutationObserver: kill any .pac-container Google tries to create
    var pacObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains("pac-container")) {
            node.remove();
          }
        });
      });
    });
    pacObserver.observe(document.body, { childList: true });

    // Force-hide pac-container via CSS (belt + suspenders)
    var pacKillCSS = document.createElement("style");
    pacKillCSS.textContent = ".pac-container { display: none !important; visibility: hidden !important; }";
    document.head.appendChild(pacKillCSS);

    var service = new google.maps.places.AutocompleteService();
    var placesService = new google.maps.places.PlacesService(document.createElement("div"));
    var bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(QLD_BOUNDS.south, QLD_BOUNDS.west),
      new google.maps.LatLng(QLD_BOUNDS.north, QLD_BOUNDS.east)
    );

    // Create custom dropdown
    var dropdown = document.createElement("div");
    dropdown.id = "tf-custom-dropdown";

    var isMobile = window.innerWidth <= 768 || ("ontouchstart" in window);

    if (isMobile) {
      // MOBILE: Fixed position above keyboard, doesn't cover input
      dropdown.style.cssText = [
        "display:none",
        "position:fixed",
        "z-index:99999",
        "background:#fff",
        "border-radius:16px 16px 0 0",
        "box-shadow:0 -4px 32px rgba(0,0,0,0.25)",
        "max-height:40vh",
        "overflow-y:auto",
        "bottom:0",
        "left:0",
        "right:0",
        "width:100%",
        "font-family:Inter,system-ui,sans-serif",
        "-webkit-overflow-scrolling:touch",
        "padding-bottom:env(safe-area-inset-bottom, 0px)"
      ].join(";");
      document.body.appendChild(dropdown);
    } else {
      // DESKTOP: Absolute below input
      dropdown.style.cssText = [
        "display:none",
        "position:absolute",
        "z-index:99999",
        "background:#fff",
        "border-radius:12px",
        "box-shadow:0 8px 32px rgba(0,0,0,0.2)",
        "max-height:260px",
        "overflow-y:auto",
        "margin-top:4px",
        "width:100%",
        "left:0",
        "font-family:Inter,system-ui,sans-serif",
        "-webkit-overflow-scrolling:touch"
      ].join(";");
      var wrapper = input.parentElement;
      if (wrapper) {
        wrapper.style.position = "relative";
        wrapper.appendChild(dropdown);
      }
    }

    var debounceTimer = null;
    // Track if user is interacting with dropdown (prevents blur-close on iOS)
    var interactingWithDropdown = false;

    function showPredictions(predictions) {
      if (!predictions || !predictions.length) {
        dropdown.style.display = "none";
        return;
      }

      // FILTER: Only show QLD results
      var qldPreds = predictions.filter(function(pred) {
        var desc = (pred.description || "").toUpperCase();
        var secondary = ((pred.structured_formatting || {}).secondary_text || "").toUpperCase();
        return desc.indexOf("QLD") !== -1 || secondary.indexOf("QLD") !== -1 ||
               desc.indexOf("QUEENSLAND") !== -1 || secondary.indexOf("QUEENSLAND") !== -1;
      });

      if (!qldPreds.length) {
        dropdown.style.display = "none";
        return;
      }

      dropdown.innerHTML = "";

      // Mobile: add header + scroll input into view
      if (isMobile) {
        var header = document.createElement("div");
        header.style.cssText = "padding:12px 16px 8px;font-size:13px;color:#64748b;font-weight:600;border-bottom:1px solid #e2e8f0;display:flex;justify-content:space-between;align-items:center;";
        header.innerHTML = '<span>QLD Addresses</span><span style="cursor:pointer;font-size:18px;padding:4px 8px;" id="tf-dd-close">✕</span>';
        dropdown.appendChild(header);
        header.querySelector("#tf-dd-close").addEventListener("click", function(e) {
          e.preventDefault();
          dropdown.style.display = "none";
        });
        // Scroll input into view so user can still see what they're typing
        setTimeout(function() { input.scrollIntoView({ behavior: "smooth", block: "start" }); }, 100);
      }

      qldPreds.forEach(function(pred) {
        var item = document.createElement("div");
        item.className = "tf-ac-item";
        item.innerHTML = '<div style="display:flex;align-items:center;gap:10px;pointer-events:none;">' +
          '<span style="color:#94a3b8;font-size:18px;pointer-events:none;">📍</span>' +
          '<div style="pointer-events:none;">' +
            '<div style="font-size:15px;color:#0f172a;font-weight:500;">' + escapeHtml(pred.structured_formatting.main_text) + '</div>' +
            '<div style="font-size:13px;color:#64748b;">' + escapeHtml(pred.structured_formatting.secondary_text || "") + '</div>' +
          '</div></div>';

        item.style.cssText = [
          "padding:16px",
          "cursor:pointer",
          "border-bottom:1px solid #f1f5f9",
          "-webkit-tap-highlight-color:rgba(23,162,184,0.15)",
          "touch-action:manipulation",
          "user-select:none",
          "-webkit-user-select:none",
          "min-height:52px"
        ].join(";");

        // iOS-safe selection handler
        function doSelect(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
          interactingWithDropdown = false;
          selectPrediction(pred);
        }

        // CRITICAL: mousedown preventDefault stops input blur on ALL browsers
        item.addEventListener("mousedown", function(e) {
          e.preventDefault();
          interactingWithDropdown = true;
        });

        // touchstart: prevent default to stop iOS blur + scroll-to-tap issues
        item.addEventListener("touchstart", function(e) {
          e.preventDefault();
          interactingWithDropdown = true;
          this.style.background = "#e0f2fe";
        }, { passive: false });

        // touchend: actually perform the selection
        item.addEventListener("touchend", function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.style.background = "";
          doSelect(e);
        }, { passive: false });

        // click: desktop fallback
        item.addEventListener("click", doSelect);

        // Hover effects (desktop)
        item.addEventListener("mouseenter", function() { this.style.background = "#f0f8ff"; });
        item.addEventListener("mouseleave", function() { this.style.background = ""; });

        // Cancel touch if user drags (scrolling the dropdown)
        item.addEventListener("touchmove", function() {
          interactingWithDropdown = false;
          this.style.background = "";
        }, { passive: true });

        dropdown.appendChild(item);
      });

      dropdown.style.display = "block";
    }

    function selectPrediction(prediction) {
      dropdown.style.display = "none";
      dropdown.innerHTML = "";
      input.value = prediction.description;

      placesService.getDetails(
        { placeId: prediction.place_id, fields: ["formatted_address", "address_components"] },
        function(place, status) {
          if (status !== "OK" || !place) {
            setAddress(prediction.description);
            input.classList.add("valid-address");
            return;
          }

          var inQLD = (place.address_components || []).some(function(c) {
            return c.types.indexOf("administrative_area_level_1") !== -1 &&
              (c.short_name === "QLD" || c.long_name === "Queensland");
          });

          if (!inQLD) {
            input.value = "";
            input.classList.remove("valid-address");
            alert("Sorry, we only service Queensland properties. Please enter a QLD address.");
            input.focus();
            return;
          }

          var addr = place.formatted_address || prediction.description;
          input.value = addr;
          input.classList.add("valid-address");
          setAddress(addr);
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      );
    }

    // Input handler with debounce
    input.addEventListener("input", function() {
      var val = input.value.trim();
      input.classList.remove("valid-address");

      if (val.length < 2) {
        dropdown.style.display = "none";
        return;
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        service.getPlacePredictions(
          {
            input: val,
            types: ["address"],
            componentRestrictions: { country: "AU" },
            locationBias: bounds
          },
          function(preds, st) {
            showPredictions(st === "OK" ? preds : null);
          }
        );
      }, 200);
    });

    // Close dropdown when clicking/tapping outside
    // Use setTimeout to let touch events on items fire first
    document.addEventListener("click", function(e) {
      if (interactingWithDropdown) return;
      if (!e.target.closest("#tf-custom-dropdown") && e.target !== input) {
        dropdown.style.display = "none";
      }
    });

    // On iOS, blur fires when tapping dropdown items.
    // Don't close dropdown on blur if user is interacting with it.
    input.addEventListener("blur", function() {
      if (interactingWithDropdown) return;
      // Small delay: let touch events resolve before hiding
      setTimeout(function() {
        if (!interactingWithDropdown) {
          dropdown.style.display = "none";
        }
      }, 300);
    });

    // Re-show dropdown on focus if there's text
    input.addEventListener("focus", function() {
      var val = input.value.trim();
      if (val.length >= 3 && dropdown.children.length > 0) {
        dropdown.style.display = "block";
      }
    });

    input.addEventListener("keydown", function(e) {
      if (e.key === "Escape") dropdown.style.display = "none";
    });

    // Restore saved address
    var saved = getAddress();
    if (saved) {
      input.value = saved;
      input.classList.add("valid-address");
    }

    input.setAttribute("autocomplete", "off");
    input.setAttribute("autocorrect", "off");
    input.setAttribute("autocapitalize", "off");
    input.setAttribute("spellcheck", "false");
    input.__customAC = true;
    window.__tfAutocomplete = true;
  };

  // =========================================================
  // HERO SUBMIT
  // =========================================================
  function handleHeroSubmit() {
    var input = document.getElementById("address-input");
    if (!input) return;

    var address = input.value.trim();
    if (!address || address !== getAddress()) {
      alert("Please select a valid Queensland property address from the dropdown.");
      input.focus();
      return;
    }
    window.location.href = "/collections/titles?address=" + encodeURIComponent(address);
  }

  // =========================================================
  // ADDRESS BANNER (collection/product/cart pages)
  // =========================================================
  function showAddressBanner() {
    var address = getAddress();
    if (!address) return;

    var isRelevant = window.location.pathname.indexOf("/collections/") !== -1 ||
      window.location.pathname.indexOf("/products/") !== -1 ||
      window.location.pathname.indexOf("/cart") !== -1;

    if (!isRelevant || document.getElementById("tf-address-banner")) return;

    var banner = document.createElement("div");
    banner.id = "tf-address-banner";
    banner.innerHTML = '<div style="max-width:1100px;margin:0 auto;display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap;">' +
      '<span style="font-size:15px;">📍 Property: <strong>' + escapeHtml(address) + '</strong></span>' +
      '<button onclick="window.tfClearAddress()" style="background:rgba(255,255,255,0.2);border:1px solid rgba(255,255,255,0.3);color:white;padding:4px 12px;border-radius:6px;font-size:12px;cursor:pointer;">Change Address</button>' +
      '</div>';
    banner.style.cssText = "background:linear-gradient(90deg,#0c2d48,#145369);color:white;padding:12px 16px;text-align:center;font-family:Inter,system-ui,sans-serif;position:sticky;top:0;z-index:9999;box-shadow:0 2px 8px rgba(0,0,0,0.15);";

    var main = document.getElementById("MainContent") || document.querySelector("main") || document.body;
    main.insertBefore(banner, main.firstChild);
  }

  window.tfClearAddress = function() {
    localStorage.removeItem(STORAGE_KEY);
    var banner = document.getElementById("tf-address-banner");
    if (banner) banner.remove();
    window.location.href = "/";
  };

  // =========================================================
  // INJECT ADDRESS INTO PRODUCT FORMS
  // =========================================================
  function injectAddressIntoProductForm() {
    var address = getAddress();
    if (!address || window.location.pathname.indexOf("/products/") === -1) return;

    function tryInject() {
      var forms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      if (forms.length === 0) return false;
      forms.forEach(function(form) {
        if (!form.querySelector('input[name="properties[Property Address]"]')) {
          var hidden = document.createElement("input");
          hidden.type = "hidden";
          hidden.name = "properties[Property Address]";
          hidden.value = address;
          form.appendChild(hidden);
        }
      });
      return true;
    }

    if (!tryInject()) {
      var attempts = 0;
      var interval = setInterval(function() {
        if (tryInject() || ++attempts > 10) clearInterval(interval);
      }, 500);
    }
  }

  // =========================================================
  // CART ENHANCEMENTS
  // =========================================================
  function enhanceCartDisplay() {
    if (window.location.pathname.indexOf("/cart") === -1) return;
    var address = getAddress();
    if (!address) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { "Property Address": address } })
    }).catch(function() {});
  }

  function interceptAjaxCart() {
    var address = getAddress();
    if (!address) return;

    var origFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === "string" && url.indexOf("/cart/add") !== -1 && options && options.body) {
        try {
          var body;
          if (typeof options.body === "string") {
            body = JSON.parse(options.body);
          } else if (options.body instanceof FormData) {
            if (!options.body.has("properties[Property Address]")) {
              options.body.append("properties[Property Address]", address);
            }
            return origFetch.call(this, url, options);
          }
          if (body && typeof body === "object") {
            body.properties = body.properties || {};
            if (!body.properties["Property Address"]) {
              body.properties["Property Address"] = address;
            }
            options.body = JSON.stringify(body);
          }
        } catch (e) {}
      }
      return origFetch.call(this, url, options);
    };
  }

  // =========================================================
  // INIT
  // =========================================================
  function init() {
    // Hero button
    var heroBtn = document.getElementById("search-button");
    if (heroBtn && !heroBtn.__tfWired) {
      heroBtn.addEventListener("click", handleHeroSubmit);
      heroBtn.__tfWired = true;
    }

    // Hero input enter key
    var heroInput = document.getElementById("address-input");
    if (heroInput && !heroInput.__tfWired) {
      heroInput.addEventListener("keydown", function(e) {
        if (e.key === "Enter") { e.preventDefault(); handleHeroSubmit(); }
      });
      heroInput.__tfWired = true;
    }

    // Init autocomplete if Google Maps ready
    if (window.google && window.google.maps && window.google.maps.places) {
      window.initTFAddressAutocomplete();
    }

    showAddressBanner();

    // Pre-fill product page address input
    var productInput = document.getElementById("product-address-input");
    if (productInput && !productInput.value && getAddress()) {
      productInput.value = getAddress();
      productInput.style.borderColor = "#10b981";
      productInput.style.backgroundColor = "#f0fdf4";
    }

    injectAddressIntoProductForm();
    enhanceCartDisplay();
    interceptAjaxCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function() {
    if (document.getElementById("address-input") && !window.__tfAutocomplete) {
      var retries = 0;
      var interval = setInterval(function() {
        if (window.google && window.google.maps && window.google.maps.places) {
          window.initTFAddressAutocomplete();
          clearInterval(interval);
        } else if (++retries > 5) {
          clearInterval(interval);
        }
      }, 1000);
    }
    injectAddressIntoProductForm();
  });

  // Mobile CSS
  var tfCSS = document.createElement("style");
  tfCSS.textContent = [
    "#tf-custom-dropdown div.tf-ac-item:active { background: #e0f2fe !important; }",
    "@media (max-width: 768px) {",
    "  #tf-custom-dropdown { max-height: 200px; border-radius: 8px; }",
    "  #tf-custom-dropdown .tf-ac-item { padding: 16px !important; min-height: 52px !important; }",
    "}"
  ].join("\n");
  document.head.appendChild(tfCSS);
})();

// Aggressive self-init polling (catches race conditions with Google Maps)
(function() {
  var attempts = 0, maxAttempts = 50;
  function tryInit() {
    if (typeof window.initTFAddressAutocomplete === "function" &&
        window.google && window.google.maps && window.google.maps.places &&
        document.getElementById("address-input") && !window.__tfAutocomplete) {
      window.initTFAddressAutocomplete();
    } else if (++attempts < maxAttempts) {
      setTimeout(tryInit, 100);
    }
  }
  tryInit();
  document.addEventListener("DOMContentLoaded", tryInit);
  window.addEventListener("load", tryInit);
})();
